import { createDecorator } from 'vue-class-component';
export function MapGetters(moduleName, type) {
    return createDecorator(function (options, key) {
        if (!options.computed) {
            options.computed = {};
            return;
        }
        options.computed[key] = function () {
            return this.$store.getters["".concat(moduleName, "/").concat(type)];
        };
    });
}
export function MapState(type) {
    return createDecorator(function (options, key) {
        if (!options.computed) {
            options.computed = {};
            return;
        }
        options.computed[key] = function () {
            return this.$store.state[type];
        };
    });
}
